import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {CommandService} from '@core/services/command.service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Injectable({
  providedIn: 'root',
})

export class AddPlatformFieldsCommandHandler implements IPlatformCommandHandler {
  constructor(
    private platformQueryService: PlatformQueryService,
    private dialogService: DialogService,
    private commandService: CommandService,
    private fuseSplaceScreenService: FuseSplashScreenService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const flowChartSectionQueryCommand = new PlatformQuery();
    flowChartSectionQueryCommand.name = 'FlowchartSectionByIdQuery';
    // if the original command is wrapped inside current command as external command
    if (command.fieldValues['ExternalCommandApi']) {
      flowChartSectionQueryCommand.api = command.fieldValues['ExternalCommandApi'];
    } else {
      flowChartSectionQueryCommand.api = command.api;
    }
    //
    flowChartSectionQueryCommand.fieldValues['FlowchartSectionId'] = command.fieldValues['FlowchartSectionId'];
    flowChartSectionQueryCommand.fieldValues['IncludeFieldKeys'] = true;
    flowChartSectionQueryCommand.fieldValues['IncludeMetaData'] = true;
    this.platformQueryService.executeQuery(flowChartSectionQueryCommand).subscribe(response => {
      //
      const sourceType = response.fieldValues['MetaData']?.SourceType;
      const api = response.fieldValues['MetaData']?.FieldSourceApi;
      const QuestionnaireFieldConfigId = response.fieldValues['MetaData']?.QuestionnaireFieldConfigId;
      const selectedFieldKeys = response.fieldValues['FieldKeys'] || [];
      this.openItpFieldSelector(command, handler, sourceType, api, selectedFieldKeys, QuestionnaireFieldConfigId);
    });
    return true;
  }
  openItpFieldSelector(command: PlatformCommand, handler: IPlatformToolHandler, sourceType: string,
                       api: string, selectedFieldKeys: string[], questionnaireFieldConfigId: string) {
    const dataCollectorComponent = command.fieldValues['DataCollectionComponent'] || 'GenericFieldSelectorComponent';
    const IsSource = command.fieldValues['IsSource'] || false;
    const dialogModel: DialogModel = DialogModel.create(
      'Add Fields (Orbitax)',
      dataCollectorComponent, {
        SourceType: sourceType,
        SourceApi: api,
        QuestionnaireFieldConfigId: questionnaireFieldConfigId,
        SelectedFieldKeys: selectedFieldKeys ? selectedFieldKeys : [],
        IsSource: IsSource
      },
      '800px',
      '800px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        this.fuseSplaceScreenService.show();
        command.fieldValues['SelectedFieldKeys'] = dialogModel.input['SelectedFieldKeys'];
        command.fieldValues['SourceType'] = dialogModel.input['SelectedSource'].sourceType;
        command.fieldValues['FieldSourceApi'] = dialogModel.input['SelectedSource'].apiName;
        command.fieldValues['QuestionnaireFieldConfigId'] = dialogModel.input['SelectedSource'].id;
        if(dialogModel.input['QnrTitle']){
          command.fieldValues['QnrTitle'] = dialogModel.input['QnrTitle'];
        }
        if(command.fieldValues["DataCollectionId"]){
          command.fieldValues['QnrTitle'] = dialogModel.input['SelectedSource'].title;
        }
        this.commandService.executePlatformCommand(command).subscribe((res) => {
          if(command.fieldValues['DataCollectionId']){
            const createItpFieldsQnrSuccessCommand = new PlatformCommand('CreateITPFieldsQnrSuccessCommand', 'FlowApi');
            createItpFieldsQnrSuccessCommand.fieldValues = {
              'PlatformLinkId': handler?.magicLinkModel.id,
              'Title': command.fieldValues['QnrTitle'],
              'DataCollectionId': command.fieldValues['DataCollectionId'],
              'IsSource': command.fieldValues['IsSource'],
              'FilePath': res.fieldValues['FilePath'],
              'ItpFieldSourceType': dialogModel.input['SelectedSource'].sourceType,
              'DataSourceType': command.fieldValues['DataSourceType']
            };
            this.commandService.executePlatformCommand(createItpFieldsQnrSuccessCommand).pipe(take(1)).subscribe(commandResponse => {
                this.fuseSplaceScreenService.hide();
                if (commandResponse.fieldValues['Refresh'] === true) {
                  handler.invalidateSubject.invalidate('Refresh');
                } else {
                  handler.invalidateSubject.invalidate();
                }
              });
          }
          else{
            this.fuseSplaceScreenService.hide();
            handler.invalidateSubject.invalidate();
          }
        });
      }
    });
  }
}
